module.exports = __webpack_public_path__ + "static/media/app-divida-ativa.36230d96.webp";